import * as React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { TR } from 'src/TextRes';
import Footer from '../../components/footer/Footer';
import HeaderLoggedOut from '../../components/headerLoggedOut/HeaderLoggedOut';
import './Logout.css';

export default class Login extends React.PureComponent {
    public render() {
        return (
            <>
                <HeaderLoggedOut />
                <Container id="logoutView" className="text-center">
                    <Row>
                        <Col>
                            <h3>{TR.logout_success}</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={6} className="offset-md-3">
                            {TR.logout_if_you_want} <a href="/">{TR.logout_log_back_in}</a>
                        </Col>
                    </Row>
                </Container>
                <Footer />
            </>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/logout/Logout.tsx